import { Download } from "@mui/icons-material";
import { PDFDocument } from "pdf-lib";
import { useState } from "react";
import FileError from "../../../../../components/Icons/ErrorFile";
import { useActaDetalleStore } from "../../../../../store/actaDetalleStore";
import pdfBlanco from '../../../../../assets/pdf-blanco.pdf';
import { useGeneralAppStore } from "../../../../../store/generalAppStore";
import { MuniSpinner2 } from "../../../../../components";

const TabPdf = () => {
  const { actaDetalle } = useActaDetalleStore();
  const { archivos } = actaDetalle;
  const [pdfSelect, setPdfSelect] = useState(
    archivos?.actas?.length > 0 ? archivos?.actas[0] : null
  );
  const { loads } = useGeneralAppStore();

  // console.log(pdfSelect.tipo_acta)


  const [opc, setOpc] = useState(0);

  const descargarAvisos = async (pdfUrl, acta) => {
    try {
      // Fetch the PDF file as a binary
      const existingPdfBytes = await fetch(pdfUrl).then((res) => res.arrayBuffer());

      // Load the PDF document
      const pdfDoc = await PDFDocument.load(existingPdfBytes);

      // Extract the third page (Index 2 since it's zero-based)
      const [thirdPage] = await pdfDoc.copyPages(pdfDoc, [2]);

      // Create a new PDF and add the copied third page
      const newPdfDoc = await PDFDocument.create();
      const [copiedThirdPage] = await newPdfDoc.copyPages(pdfDoc, [2]);
      newPdfDoc.addPage(copiedThirdPage);

      // Serialize the PDF to bytes
      const pdfBytes = await newPdfDoc.save();

      // Create a Blob and trigger the download
      const blob = new Blob([pdfBytes], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `avisos-acta-${acta.acta.dependencia}-${acta.acta.numero_acta}.pdf`;
      link.click();
    } catch (error) {
      console.error("Error downloading third page:", error);
    }
  };

  return (
    <>
      <div className="mx-auto ">
        <div className="d-flex gap-2 ">
          <div className="d-flex flex-column w-fit p-4 gap-2">
            {archivos?.actas && (
              <>
                {archivos.actas.map((archivo, index) => {
                  return (
                    <span
                      className={`fw-bold  py-1 px-2 ${opc == index && "text-light"}`}
                      style={{ cursor: "pointer", backgroundColor: opc == index && "#323639" }}
                      key={index}
                      onClick={() => {
                        setPdfSelect(archivo);
                        setOpc(index);
                      }}
                    >
                      Acta {archivo.tipo_acta}
                    </span>
                  );
                })}
                <a
                  href={pdfSelect.file}
                  download={`${actaDetalle?.acta.dependencia}-${actaDetalle?.acta.numero_acta}-${pdfSelect.tipo_acta}`}
                  className="text-center mb-3  d-block  bg-success text-light px-2 py-1 rounded"
                  style={{ border: "2px #FFF ", right: "0", top: "-50px", textDecoration: "none", fontSize: "13px", width: "154.69px", }}
                >
                  <Download />
                  DESCARGAR ACTA
                </a>
                {/* {
                  pdfSelect.tipo_acta == "fisica" &&

                  <button
                    className="text-center mb-3  d-block bg-primary text-light px-2 py-1 fw-bold rounded "
                    style={{
                      width:"154.69px",
                      fontSize:"13px",
                      border: "2px #FFF",
                      right: "0",
                      top: "-50px",
                      textDecoration: "none",
                    }}
                    onClick={() => descargarAvisos(pdfSelect.file, actaDetalle)}
                  >
                    <Download />
                    DESCARGAR AVISO
                  </button>
                } */}
              </>
            )}
          </div>
          <div className="col " style={{ height: "80vh" }}>
            {pdfSelect?.es_pesada ? (
              <div className="d-flex  justify-content-center h-100 align-items-center border border-1 border-secondary">
                <label
                  className="py-3 px-5 rounded text-danger  d-flex gap-2"
                  style={{ border: "4px dotted gray", width: "fit-content" }}
                >
                  <FileError />
                  El PDF no se puede mostrar, es muy pesado
                </label>
              </div>
            ) : (
              // <iframe className="mx-auto" src={pdfSelect.file} height={"100%"} width={"100%"} />
              loads.includes("editar_acta")
                ?
                <div className="d-flex w-100 h-100 position-relative d-flex justify-content-center align-items-center">
                  <div className="position-absolute w-75 h-75 d-flex justify-content-center">
                    <MuniSpinner2 />
                  </div>
                  <object type="application/pdf" data={pdfBlanco} height={"100%"} width={"100%"} />
                </div>
                :
                <object type="application/pdf" data={pdfSelect?.file} height={"100%"} width={"100%"} />

            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TabPdf;
